import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.625 10.75a2.252 2.252 0 002.25-2.25 2.252 2.252 0 00-2.25-2.25 2.252 2.252 0 00-2.25 2.25 2.252 2.252 0 002.25 2.25zm1.125 1.125H16.5c-.619 0-1.178.25-1.585.654a5.143 5.143 0 012.64 3.846h2.32c.622 0 1.125-.503 1.125-1.125v-1.125a2.252 2.252 0 00-2.25-2.25zm-9 0a3.935 3.935 0 003.938-3.938A3.935 3.935 0 009.75 4a3.936 3.936 0 00-3.938 3.938 3.935 3.935 0 003.938 3.937zM12.45 13h-.292a5.537 5.537 0 01-2.408.563A5.55 5.55 0 017.342 13H7.05A4.051 4.051 0 003 17.05v1.012c0 .932.756 1.688 1.688 1.688h10.125c.931 0 1.687-.756 1.687-1.688V17.05A4.051 4.051 0 0012.45 13z"
});

function People(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "title", "titleId"]);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

People.sizes = sizes;
People.defaultProps = {
  size: sizes.md
};
People.propTypes = {
  size: PropTypes.oneOf([People.sizes.xs, People.sizes.sm, People.sizes.md, People.sizes.lg, People.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default People;